import * as yup from "yup";

export const AddJobPositionSchema = (t) => {
  return yup.object().shape({
    serial_number: yup.string(),
    // .required(t('organizations.job_postion_validation.serialNumberRequired')),
    abbreviation: yup
      .string()
      .required(t("organizations.job_postion_validation").abbreviationRequired)
      .max(30, t("organizations.job_postion_validation.abbreviationMax")),
    difficulty_coefficient: yup.string().notRequired(),
    // .required(
    //   t('organizations.job_postion_validation.difficultyCoefficientRequired')
    // ),
    work_experience: yup.string().notRequired(),
    // .required(t('organizations.job_postion_validation.workExperienceRequired')),
    name: yup
      .string()
      .required(t("organizations.job_postion_validation.titleRequired"))
      .max(30, t("organizations.job_postion_validation.titleMax")),
    required_knowledge_and_skill_id: yup.string().notRequired(),
    // .required(t('organizations.job_postion_validation.knowledgeAndSkillsRequired')),
    allocated_number_of_employees: yup
      .string()
      .required(t("organizations.job_postion_validation").numberOfSeatsRequired)
      .matches(
        /^\d+$/,
        t("organizations.job_postion_validation").numberOfSeatsNumber
      ),
    minimum_number_of_employees: yup
      .string()
      .required(
        t("organizations.job_postion_validation")
          .minimumNumberOfEmployeesRequired
      )
      .matches(
        /^\d+$/,
        t("organizations.job_postion_validation").minimumNumberOfEmployeesNumber
      )
      .test(
        "is-allocated-valid",
        t("organizations.job_postion_validation").minimumEmployeesValid,
        function (value, context) {
          return (
            parseInt(value, 10) <=
            parseInt(context.parent.allocated_number_of_employees, 10)
          );
        }
      ),
    special_requirement_id: yup.string().notRequired(),
    // .required(t('organizations.job_postion_validation.specialRequirementsRequired')),
    unit_id: yup
      .string()
      .required(
        t("organizations.job_postion_validation").organizationalUnitRequired
      ),
    parent_id: yup
      .string()
      .required(t("organizations.job_postion_validation.parentRequired")),
    location_id: yup
      .string()
      .required(t("organizations.job_postion_validation.locationRequired")),
    foreign_language_id: yup.string().notRequired(),
    // .required(t('organizations.job_postion_validation.languageKnowledgeRequired')),
    educational_qualification_id: yup
      .string()
      .required(
        t("organizations.job_postion_validation")
          .educationalQualificationRequired
      ),
    description: yup
      .string()
      .required(t("organizations.job_postion_validation").descriptionRequired)
      .max(300, t("organizations.job_postion_validation.descriptionMax")),
  });
};
